var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserDefaultLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 94,
    height: 94,
    rx: 47,
    fill: "white",
    fillOpacity: 0.2,
    stroke: "#C5C5C5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6036 47.5196C55.2156 50.6936 52.0716 52.7436 48.5996 52.7436C45.1296 52.7436 41.9896 50.6936 40.5976 47.5196C40.2656 46.7616 40.6096 45.8776 41.3696 45.5436C42.1336 45.2136 43.0136 45.5576 43.3456 46.3156C44.2596 48.3976 46.3196 49.7436 48.5996 49.7436C50.8816 49.7436 52.9456 48.3976 53.8576 46.3156C54.1896 45.5556 55.0776 45.2096 55.8316 45.5436C56.5916 45.8756 56.9376 46.7616 56.6036 47.5196ZM58.7236 30.6797H38.4796C33.8596 30.6797 30.1016 34.4497 30.1016 39.0837V52.9616C30.1016 57.5976 33.8596 61.3676 38.4796 61.3676H40.6176C41.6236 61.3676 42.6056 61.7756 43.3136 62.4876L46.1576 65.3416C46.8116 65.9976 47.6796 66.3576 48.6016 66.3576C49.5256 66.3576 50.3936 65.9956 51.0436 65.3416L53.8876 62.4896C54.6116 61.7676 55.5696 61.3676 56.5876 61.3676H58.7236C63.3436 61.3676 67.1016 57.5976 67.1016 52.9616V39.0837C67.1016 34.4497 63.3436 30.6797 58.7236 30.6797Z",
    fill: "#841474"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefaultLogo);
export default __webpack_public_path__ + "static/media/user-default-logo.809d7c6b18f37f4ddec3af9ced107c98.svg";
export { ForwardRef as ReactComponent };